/* =========================================================
   ParcelPanel – Mobile Progress Icons (FINAL + OFFSET)
   16% + 32% with exact PC parity
   Icons moved down using transform (mobile-proof)
   ========================================================= */

(function () {
  if (window.innerWidth > 768) return;

  const CONFIG = {
    cutting: {
      text: 'Mosaic Tailoring in Progress',
      gif: 'https://cdn.shopify.com/s/files/1/0573/6893/6550/files/merged_5.gif?v=1770232267',
      static: 'https://cdn.shopify.com/s/files/1/0573/6893/6550/files/Artboard_1_4_HIGH_RES.png?v=1770840469',
      grey: 'https://cdn.shopify.com/s/files/1/0573/6893/6550/files/Artboard_1_3_HIGH_RES.png?v=1770840469'
    },
    assembling: {
      text: 'Mosaic Is Being Assembled',
      gif: 'https://cdn.shopify.com/s/files/1/0573/6893/6550/files/merged_10.gif?v=1770233714',
      static: 'https://cdn.shopify.com/s/files/1/0573/6893/6550/files/icon5-11.png?v=1770234373',
      grey: 'https://cdn.shopify.com/s/files/1/0573/6893/6550/files/icon5-10.png?v=1770234533'
    }
  };

  const ICON_SIZE = 46;
  let observer;

  /* ---------------------------------------------------------
     Move icon wrapper down (transform always wins)
     --------------------------------------------------------- */
  function moveIconDown(step) {
    const iconWrapper = step.querySelector('.icon.icon-svg');
    if (!iconWrapper) return;

    iconWrapper.style.transform = 'translateY(17px)';
  }

  function applyIcon(step, src, state) {
    const icon = step.querySelector('.icon.icon-svg');
    if (!icon) return;

    const existing = icon.querySelector('.pw-custom-icon');
    if (existing && existing.getAttribute('data-src') === src) return;

    if (observer) observer.disconnect();

    const svg = icon.querySelector('svg');
    if (svg) svg.remove();
    if (existing) existing.remove();

    const img = document.createElement('img');
    img.className = 'pw-custom-icon';
    img.src = src;
    img.setAttribute('data-src', src);
    img.width = ICON_SIZE;
    img.height = ICON_SIZE;
    img.style.objectFit = 'contain';

    /* Grey icons = 50% opacity */
    if (state === 'grey') {
      img.style.opacity = '0.5';
    }

    icon.appendChild(img);

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function updateIcons() {
    const steps = [...document.querySelectorAll('.progress-bar-mobile-list')];
    if (!steps.length) return;

    const cuttingStep = steps.find(s =>
      s.querySelector('.progress-bar-mobile-content b')?.textContent.trim() === CONFIG.cutting.text
    );

    const assemblingStep = steps.find(s =>
      s.querySelector('.progress-bar-mobile-content b')?.textContent.trim() === CONFIG.assembling.text
    );

    /* Apply vertical offset (always) */
    if (cuttingStep) moveIconDown(cuttingStep);
    if (assemblingStep) moveIconDown(assemblingStep);

    const cuttingActive =
      cuttingStep?.classList.contains('progress-bar-mobile-node--active');
    const cuttingCompleted =
      cuttingStep?.classList.contains('progress-bar-mobile-node--completed');

    const assemblingActive =
      assemblingStep?.classList.contains('progress-bar-mobile-node--active');
    const assemblingCompleted =
      assemblingStep?.classList.contains('progress-bar-mobile-node--completed');

    /* ---------- CUTTING (16%) ---------- */
    if (cuttingStep) {
      if (cuttingActive && !assemblingActive) {
        applyIcon(cuttingStep, CONFIG.cutting.gif, 'gif');
      } else if (cuttingCompleted || assemblingActive) {
        applyIcon(cuttingStep, CONFIG.cutting.static, 'static');
      } else {
        applyIcon(cuttingStep, CONFIG.cutting.grey, 'grey');
      }
    }

    /* ---------- ASSEMBLING (32%) ---------- */
    if (assemblingStep) {
      const orderReadyStep = steps.find(s =>
        s.querySelector('.progress-bar-mobile-content b')?.textContent.trim() === 'Order Ready'
      );

      const orderReadyActive =
        orderReadyStep?.classList.contains('progress-bar-mobile-node--active');

      if (orderReadyActive || assemblingCompleted) {
        applyIcon(assemblingStep, CONFIG.assembling.static, 'static');
      } else if (assemblingActive) {
        applyIcon(assemblingStep, CONFIG.assembling.gif, 'gif');
      } else {
        applyIcon(assemblingStep, CONFIG.assembling.grey, 'grey');
      }
    }
  }

  updateIcons();

  observer = new MutationObserver(updateIcons);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
(function () {
  function updateTimelineIcons() {
    const items = document.querySelectorAll('.timeline-item');

    items.forEach(item => {
      const text = item.innerText || '';
      const badge = item.querySelector('.timeline-badge.timeline-item__badge');
      if (!badge) return;

      // Mosaic Cutting
      if (text.includes('Mosaic Tailoring in Progress')) {
        badge.style.backgroundImage =
          'url("https://cdn.shopify.com/s/files/1/0573/6893/6550/files/Artboard_1_4.svg?v=1770224536")';
        badge.style.backgroundSize = '60%';
        badge.style.backgroundRepeat = 'no-repeat';
        badge.style.backgroundPosition = 'center';
      }

      // Mosaic Assembling
      if (text.includes('Mosaic Is Being Assembled')) {
        badge.style.backgroundImage =
          'url("https://cdn.shopify.com/s/files/1/0573/6893/6550/files/icon5-11.png?v=1770234373")';
        badge.style.backgroundSize = '60%';
        badge.style.backgroundRepeat = 'no-repeat';
        badge.style.backgroundPosition = 'center';
      }
    });
  }

  updateTimelineIcons();

  // Timeline re-renders dynamically
  const observer = new MutationObserver(updateTimelineIcons);
  observer.observe(document.body, { childList: true, subtree: true });
})();

